import { render } from "./designation-modal.vue?vue&type=template&id=5937a852"
import script from "./designation-modal.vue?vue&type=script&lang=js"
export * from "./designation-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__